/**
 * Plant Selector Form (filters)
 */
import { App } from './desertland.app';
import { Utils } from './cals.utils';
import 'kendo-ui-core';
// import 'kendo-ui-core/js/kendo.data';
import 'kendo-ui-core/js/kendo.panelbar';
import 'kendo-ui-core/js/kendo.slider';
import 'kendo-ui-core/js/kendo.multiselect';
import 'kendo-ui-core/js/kendo.slider';

/* tslint:disable variable-name prefer-for-of triple-equals */
declare var log, info, warn, groupCollapsed, groupEnd, time, timeEnd;

const FIELDSPLIT = '_-_';
const FIELDTOINFINITY = '-___';//ref plant-selector-filters.json (height, width)

export class PlantSelectorForm {
  public data: any;

  public multiselect = {
    sel: "#filters_list_multiselect",

    init: () => {
      // log("init multiselect", this);
      // multiselect to hold the filters
      let filters_list_multiselect_sel = this.multiselect.sel;
      //info($(this.sel).data("kendoMultiSelect"));//is it already defined?
      if ($(filters_list_multiselect_sel).length && !$(this.multiselect.sel).data("kendoMultiSelect")) {

        // init the datasource while creating the multiselect
        $(filters_list_multiselect_sel).kendoMultiSelect({
          dataSource: new kendo.data.DataSource(
            /*{
                data: [
                {
                    name: "Annual",
                    value: "propName:value"
                },
                {
                    name: "Blue",
                    value: "propName:value"
                },
                {
                    name: "Succulent",
                    value: "propName:value"
                }]
            }*/
          ),
          dataTextField: "name",
          dataValueField: "value",
          placeholder: "Select filters above...",
          dataBound: (e) => {
            //http://stackoverflow.com/questions/16608565/kendo-multiselect-trigger-an-event-when-an-item-is-removed
            // log(e.sender, this);
            let me = e.sender;
            this.multiselect.saveCurrent(me);
          },
          change: (e) => {
            //info("YOU ARE HERE: respond to multiselect selection changed");
            //log(e.sender);
            let me = e.sender;
            //http://stackoverflow.com/questions/17468529/how-do-i-get-the-changed-element-in-a-multiselect-using-kendoui

            // Retrieve previous value of `multiselect` saved using previous function
            let previous = (me as any)._savedOld;
            //log(previous);
            // These are current values.
            let current = me.value();
            //log(current);
            let checkId = "#filter";
            // Let's save it for the next time
            this.multiselect.saveCurrent(me);

            // The difference between previous and current are removed elements
            let diff = $(previous).not(current).get();
            if (diff.length) {
              log("removed", diff);

              for (let i = 0; i < diff.length; i++) {
                let aRemoved = Utils.splitStringToArray(diff[i], ":");
                //log(aRemoved);
                // update filters
                if (aRemoved.length === 2) {
                  // clicking it will do this
                  // App.plants.filtersRemove(aRemoved[0], aRemoved[1]);

                  // update form checkboxes
                  checkId = "#filter_" + aRemoved[0] + "_" + aRemoved[1];
                  //log(checkId);
                  if ($(checkId).length) {
                    $(checkId).click();
                  } else {
                    // info(checkId + " does not exists - what to change?");
                    info("Not a clickable item - remove filter", aRemoved[0], aRemoved[1]);
                    App.plants.filtersRemove(aRemoved[0], aRemoved[1]); // try to do it since we didn't click
                  }

                } else {
                  info("Hmm, there should be 2 in this value array to make any changes?");
                }


              }

            }

            // The difference between current and previous, are added elements
            diff = $(current).not(previous).get();
            if (diff.length) {
              log("added", diff);

              for (let j = 0; j < diff.length; j++) {
                let aAdded = Utils.splitStringToArray(diff[j], ":");
                //log(aAdded);
                // update filters
                if (aAdded.length === 2) {
                  App.plants.filtersRemove(aAdded[0], aAdded[1]);

                  // update form checkboxes
                  checkId = "#filter_" + aAdded[0] + "_" + aAdded[1];
                  //log(checkId);
                  if ($(checkId).length) {
                    $(checkId).click();
                  } else {
                    info(checkId + " does not exists - what to change?");
                  }

                } else {
                  info("Hmm, there should be 2 in this value array to make any changes?");
                }


              }
            }

          }
        });
      }

    }, //end init

    saveCurrent: (multi, doStore = false) => {
      if (doStore && !this.filterPopping) {
        this.saveFiltersToStore(multi.value());
      }
      multi._savedOld = multi.value().slice(0);
    },

    getWidget() {
      // get the multiselect object
      return $(this.sel).data("kendoMultiSelect");
    }, //end getWidget
    addToDatasource(name, val) {
      let multiselect = this.getWidget();
      if (multiselect && multiselect.dataSource) {
        multiselect.dataSource.add({ name, value: val });
        return true;
      }
      return false;
    },
    addToSelected(itemValue) {
      info('addToSelected', itemValue);
      // add it to selected
      let multiselect = this.getWidget();
      //log(multiselect.value());
      let add = [itemValue];
      let values = multiselect.value().slice();
      //log('current values: ',values);
      let merge = $.merge(values, add);
      // Clean filtering ?
      //multiselect.dataSource.filter({});
      multiselect.value($.unique(merge));
      // log('multiselect new values: ',multiselect.value());

      this.saveCurrent(multiselect, true);
    },
    removeFromSelected(itemValue) {

      let multiselect = this.getWidget();

      let subtract = [itemValue];
      // Get copy of current selected elements
      let values = multiselect.value().slice();
      //log('removeFromSelected current values: ',values);
      // Remove elements from subtract
      values = $.grep(values, function (a) {
        return $.inArray(a, subtract) == -1;// eslint-disable-line eqeqeq
      });
      // Clean filtering ?
      //multiselect.dataSource.filter({});
      // Set new values
      multiselect.value(values);
      //log('removeFromSelected new values: ',multiselect.value());

      this.saveCurrent(multiselect, true);

    },
    removeFromSelectedByPropName(propName) {
      info('removeFromSelectedByPropName', propName);
      // get the propName
      // str = str.split(',')[0];
      let multiselect = this.getWidget();
      let valueContains = [propName];
      let values = multiselect.value().slice();
      //log('removeFromSelectedByPropName[',valueContains,'] current values: ',values);
      // Remove elements from subtract
      values = $.grep(values, (a: string) => {
        //log(a);
        let thisPropName = a.split(':')[0];
        //log(thisPropName);
        return $.inArray(thisPropName, valueContains) == -1;// eslint-disable-line eqeqeq
      });
      // Clean filtering ?
      //multiselect.dataSource.filter({});
      // Set new values
      multiselect.value(values);
      //log('removeFromSelected new values: ',multiselect.value());

      this.saveCurrent(multiselect, true);

    }

  }; //end multiselect

  private filterContainerSel = "#plant_filters #subnav-search-filters-content";
  private filterPopping = false;//track when populating the selection from localstorage

  public containerExists() {
    let $filterContainer = $(this.filterContainerSel);
    if ($filterContainer.length) {
      return true;
    } else {
      return false;
    }
  }

  public getDataSource(callback) {
    App.service.load.plantFilters(callback);
  }

  public getThenRender() {
    // check if we even need to load this...
    //var $filterContainer = $(this.filterContainerSel);
    if (this.containerExists()) {
      this.getDataSource(this.render);
    } else {
      log('getThenRender container dne');
    }

  }

  public render = (data) => {
    log("plantSelForm > Render", this);
    this.data = data;
    let $filterContainer = $(this.filterContainerSel);//"#plant_filters #subnav-search-filters-content");
    if ($filterContainer.length) {

      if (typeof data.selector_filters.characteristics !== "undefined") {
        this.renderFormFromObj("#filter-characteristics", data.selector_filters.characteristics);
      } else { log("data.selector_filters.characteristics undefined -> skipping..."); }

      if (typeof data.selector_filters.growing_requirements !== "undefined") {
        this.renderFormFromObj("#filter-growing", data.selector_filters.growing_requirements);
      } else { log("data.selector_filters.growing_requirements undefined -> skipping..."); }

      if (typeof data.selector_filters.functions !== "undefined") {
        this.renderFormFromObj("#filter-function", data.selector_filters.functions);
      } else { log("data.selector_filters.growing_requirements undefined -> skipping..."); }

      // finally,
      this.initWidgets(); 

    } else { log("#plant_filters container element not found -> not rendering anything..."); }
  }

  public renderFormFromObj(container_sel, obj) {
    //info("plantSelForm > renderFromObj");
    let $cont = $(container_sel);
    if ($cont.length) {
      //info(obj);
      let numItems = obj.length;
      let modNumItems = numItems % 3;
      let floorNumItems = Math.floor(numItems / 3);
      //log("numItems = %i && mod = %i && floor = %i",numItems,modNumItems,floorNumItems);
      /*
          split into 3 arrays then send to looper
          index of col2 start = if n%3 > 0 , 2x floor(n/3) + 1
                              else 2x floor(n/3)
          index of col3 start = 2x floor(n/3) + n%3
          */

      let indexCol2Start = (modNumItems > 0 ? (floorNumItems + 1) : floorNumItems);
      let indexCol3Start = (floorNumItems * 2) + modNumItems;
      //log("indexCol2Start = %i && indexCol3Start = %i",indexCol2Start,indexCol3Start);

      let col1 = obj.slice(0, indexCol2Start);
      let col2 = obj.slice(indexCol2Start, indexCol3Start);
      let col3 = obj.slice(indexCol3Start);
      //log("col1 = %o && col2 = %o && col3 = %o",col1,col2,col3);

      // $cont.append(this.getListHtmlFromObj(col1));
      // $cont.append(this.getListHtmlFromObj(col2));
      // $cont.append(this.getListHtmlFromObj(col3));

      /*
          * <div class="container">
              <div class="row">
                  <div class="col-sm-4">
                      this.getHtmlFromObj
          */

      let $row = $(document.createElement('div')).addClass("row");
      // if (container_sel === "#filter-characteristics") {
      //     $row.addClass("hello");
      // }
      $row.append($(document.createElement('div')).addClass("col-sm-4").append(this.getListHtmlFromObj(col1)));
      $row.append($(document.createElement('div')).addClass("col-sm-4").append(this.getListHtmlFromObj(col2)));
      $row.append($(document.createElement('div')).addClass("col-sm-4").append(this.getListHtmlFromObj(col3)));

      //info( $cont, $row);

      $cont.empty().append($(document.createElement('div')).addClass("container").append($row));

    } else { log(container_sel + " container element not found -> skipping..."); }
  }

  public getListHtmlFromObj(obj) {
    /*

                <ul class="panelbar-accord">
                    <li><!-- class="k-state-active"-->
                        Plant Type
                        <div class="panelbar-accord-content">
                            options
                        </div>
                    </li>
                </ul>

        */
    //info("plantSelForm > getListHtmlFromObj",obj);
    let $ul = $(document.createElement('ul')).addClass("panelbar-accord");

    for (let i = 0; i < obj.length; i++) {

      // named array needs us to dig in to get value
      let oThis: any = {},
        addlAttrs = "",
        propName;
      for (let propertyName in obj[i]) {
        if (obj[i].hasOwnProperty(propertyName)) {
          //log(propertyName);
          oThis = obj[i][propertyName];
          propName = propertyName;
        }
      }
      // added july 8 2016
      if (typeof oThis.fieldname === "string") {
        addlAttrs = ' data-field-name="' + oThis.fieldname + '" ';
      } else if (typeof oThis.fieldname.join === "function") {
        // log("it's an array (has join)",typeof oThis.fieldname);
        //propName = oThis.fieldname.join('_-_');
        addlAttrs = ' data-field-num="' + oThis.fieldname.length + '" data-field-name="' + oThis.fieldname.join(FIELDSPLIT) + '" ';
      } else {
        console.error("where'd who go?");
      }
      //info('%s %o',propName, oThis);
      let $li = $(document.createElement('li'));
      if (!Utils.isEmpty(oThis.display) && !Utils.isEmpty(oThis.form_type)) {
        $li.html(oThis.display);
        let $content = $(document.createElement('div')).addClass("panelbar-accord-content").appendTo($li);
        let resetText = (typeof oThis.form_reset !== "undefined" ? oThis.form_reset : "Any");
        //log(oThis);
        switch (oThis.form_type) {
          case "multi":

            let $filters_ul = $(document.createElement('ul')).addClass("list-unstyled filters-list").appendTo($content);
            //createCheckboxHtml : function (propName, id, lbl, group, value, isChecked)
            $filters_ul.append($(document.createElement('li')).addClass("clearfix").html(this.createCheckboxHtml(propName, "filter_reset_" + propName, resetText, "filter_" + propName, "reset", true, addlAttrs)));

            if (!Utils.isEmpty(oThis.items)) {
              // get the items
              for (let j = 0; j < oThis.items.length; j++) {
                if (!Utils.isEmpty(oThis.items[j].display)) {
                  let bShow = true;
                  let op = (typeof oThis.items[j].op !== "undefined" ? oThis.items[j].op : "");
                  //var addData = ""; // handle the NOT operator (use addlAttrs)
                  // The supported operators are:
                  //"eq" (equal to), "neq" (not equal to), "isnull" (is equal to null), "isnotnull" (is not equal to null),
                  //"lt" (less than), "lte" (less than or equal to), "gt" (greater than), "gte" (greater than or equal to),
                  //"startswith", "endswith", "contains", "Utils.isEmpty", "isnotempty". The last five are supported only for string fields.
                  if (op) {
                    if (op === "hide") {
                      // do nothin
                      bShow = false;
                    } else {
                      addlAttrs += ' data-filter-op="' + op + '" ';
                    }
                  }

                  // switch (op) {
                  //     case "not":
                  //         addlAttrs += ' data-filter-op="not" ';
                  //         break;
                  //     case "hide":
                  //         // do nothin
                  //         bShow = false;
                  //         break;
                  // }
                  if (bShow) {
                    //$content.append($(document.createElement('div')).html(oThis.items[j].display));
                    //createCheckboxHtml : function (propName, id, lbl, group, value, isChecked)
                    $filters_ul.append($(document.createElement('li')).html(this.createCheckboxHtml(propName, "filter_" + propName + "_" + oThis.items[j].value, oThis.items[j].display, "filter_" + propName, oThis.items[j].value, false, addlAttrs)));
                  }
                }

              }

            } else {
              console.error("obj[%i].items Utils.isEmpty! -> skipping ...", i);
            }

            break;
          case "range": //NOT USED
            let slider_id = "slider_" + propName;
            let $slider = $(document.createElement('div')).attr("id", slider_id).addClass("kendo-rangeslider").append($(document.createElement('input'))).append($(document.createElement('input'))).appendTo($content);

            if (!Utils.isEmpty(oThis.values)) {
              let minVal = (!Utils.isEmpty(oThis.values.min) ? oThis.values.min : 0);
              let maxVal = (!Utils.isEmpty(oThis.values.max) ? oThis.values.max : 10);

              let range = maxVal - minVal;

              let smallStep = (range > 60) ? 2 : 1;//Math.floor(range / 10);
              let largeStep = Math.floor(range / 5);

              $slider.attr({
                "data-min-value": minVal,
                "data-max-value": maxVal,
                "data-small-step": smallStep,
                "data-large-step": largeStep
              });
            }

            // $(document.createElement('a')).attr("href","#reset-" + slider_id).attr("data-slider-to-reset", slider_id).addClass("slider-reset-action").html(resetText).appendTo($content);
            $(document.createElement('a')).attr("href", "#/plants").attr("data-slider-to-reset", slider_id).addClass("slider-reset-action").html(resetText).appendTo($content);

            break;
        }

        $li.appendTo($ul);

      } else { console.error("obj[%i].display  = undefined -> skipping ...", i); }

    }

    //var $html = $(document.createElement('div')).addClass("container").append($(document.createElement('div')).addClass("row").append($(document.createElement('div')).addClass("col-sm-4").append($ul)));
    return $ul;
  }

  public createCheckboxHtml(propName, id, lbl, group, value, isChecked, addlData) {
    /*<input type="checkbox" id="eq1" class="k-checkbox" >
    <label class="k-checkbox-label" for="eq1">Rear side airbags</label>*/
    /*
    var $ret = $(document.createElement('input')).addClass("k-checkbox").attr({
        "type":"checkbox",
        "id" : id
    });
    if (isChecked) {
        $ret.attr("checked","checked");
    }
    $ret.after($(document.createElement('label')).addClass("k-checkbox-label").attr({
        "for" : id
    }).html(lbl));*/
    let chked = (isChecked ? 'checked="checked"' : '');


    return '<input type="checkbox" name="' + group + '[]" value="' + value + '" id="' + id + '" data-filter-prop-name="' + propName + '" ' + addlData + ' data-filter-prop-display="' + propName + '" data-filter-display-name="' + lbl + '" class="k-checkbox filter-click-event" ' + chked + '><label class="k-checkbox-label break-word" for="' + id + '">' + lbl + '</label>';


  }


  public initWidgets() {

    // subnav-filters panelBar Accordians
    if ($(".panelbar-accord").length) {
      $(".panelbar-accord").kendoPanelBar();
    }
    //END: subnav-filters panelBar Accordians

    if ($(".kendo-rangeslider").length) {
      $(".kendo-rangeslider").each(function (index) {
        //log( index + ": " + $( this ).text() );

        let thisMin = Utils.tryParseInt($(this).attr("data-min-value"), 0);
        let thisMax = Utils.tryParseInt($(this).attr("data-max-value"), 10);
        let thisSmallStep = Utils.tryParseInt($(this).attr("data-small-step"), 1);
        let thisLargeStep = Utils.tryParseInt($(this).attr("data-large-step"), 2);

        $(this).kendoRangeSlider({
          min: thisMin,
          max: thisMax,
          smallStep: thisSmallStep,
          largeStep: thisLargeStep,
          tickPlacement: "both",
          tooltip: {
            format: "{0}'"
          },
          change (e) {
            //log("Change :: new slide values are: " + e.value.toString().replace(",", " - "));
            info("TODO: respond with filter update");
          },
          slide (e) {
            //log("Slide :: new values are: " + e.value.toString().replace(",", " - "));
          }
        });


      });
    }

    // create multiselect
    this.multiselect.init();


    // add offonclicks
    this.addEvents();

    // check yo localsto
    this.checkStore();

  } // end initFilterWidgets

  public toggleSearchClear() {
    if ($(".hasclear").length) {
      //info(Boolean($(".hasclear").val()), $(".hasclear").val());
      //info($(".hasclear").next('span').is(':visible'));
      $(".hasclear").next('span').toggle(Boolean($(".hasclear").val()));
    }
  }

  public clearSearchInput() {
    if ($(".clearer").length) {
      $(".clearer").prev('input').val('').focus();
      $(".clearer").hide();
    }
  }

  public addEvents() {

    //
    // subnav-filters
    //
    $('#subnav_search_filters a').off("click").on("click", function (e) {
      e.preventDefault();
      let tab = $(this);
      if (tab.parent('li').hasClass('active')) {
        window.setTimeout(function () {
          $(".tab-pane").removeClass('active');
          tab.parent('li').removeClass('active');
        }, 0.2);
      } else {
        ($(this) as any).tab('show');
      }

    });
    //END: subnav-filters


    // search box clear X functionality
    if ($(".hasclear").length && $(".clearer").length) {
      $(".hasclear").keyup(() => {
        // var t = $(this);
        // //log("keyup",Boolean(t.val()));
        // t.next('span').toggle(Boolean(t.val()));
        this.toggleSearchClear();
      });

      // let inputVal = $(this).prev('input').val();
      // $(".clearer").hide($(this).prev('input').val());  //TODO: what is this?
      $(".clearer").hide();  //TODO: what is this?

      $(".clearer").click((e) => {
        // log("clearer");
        e.preventDefault();
        e.stopPropagation();
        // $(this).prev('input').val('').focus();
        // $(this).hide();
        this.clearSearchInput();
        App.plants.clearSearch();
      });
    }



    //
    // kendo widgets
    //

    // create onclick for slider reset btns - not used anymore (sliders removed)
    if ($(".slider-reset-action").length) {
      $(".slider-reset-action").off("click").on("click", function () {
        let slider_id = $(this).attr("data-slider-to-reset");
        if (!Utils.isEmpty(slider_id)) {
          // log("reset slider: " + slider_id);

          let $el = $("#" + slider_id);
          if ($el.length) {
            let newMin = Utils.tryParseInt($el.attr("data-min-value"), 0);
            let newMax = Utils.tryParseInt($el.attr("data-max-value"), 10);

            let slider = $("#" + slider_id).data("kendoRangeSlider");
            if (slider) {
              slider.value([newMin, newMax]);

              log("TODO: respond with filter update");

            }
          }
        }
      });
    }//onclick for slider reset btns


    // handle click of filter checkboxes
    if ($(".filter-click-event").length) {
      let multiselect = this.multiselect;
      $(".filter-click-event").off("click").on("click", function () {
        let showLogs = false;

        //log($(this));
        let lastOne = false;
        let this_id = $(this).attr("id");
        let this_type = $(this).attr("type");
        let this_name = $(this).attr("name");
        let this_value = $(this).attr("value");
        let isChecked = $(this).is(':checked');
        let displayName = $(this).attr("data-filter-display-name"); // use for datasource.filterName
        let propName = $(this).attr("data-filter-prop-name");
        // var propDisplay = "";//$(this).attr("data-filter-prop-display")+": ";
        let this_op: any = $(this).attr("data-filter-op");
        // The supported operators are:
        //"eq" (equal to), "neq" (not equal to), "isnull" (is equal to null), "isnotnull" (is not equal to null),
        //"lt" (less than), "lte" (less than or equal to), "gt" (greater than), "gte" (greater than or equal to),
        //"startswith", "endswith", "contains", "Utils.isEmpty", "isnotempty". The last five are supported only for string fields.
        if (!Utils.isEmpty(this_op) && this_op === "not") {
          this_op = "neq";
        } else {
          this_op = "contains";
        }
        // added july 8 2016
        // props with multiple fields

        // addlAttrs = ' data-field-num="' + oThis.fieldname.length + '" data-field-name="' + oThis.fieldname.join('_-_') + '" ';
        /*
        "height": {
            "display": "Height",
            "fieldname": [
                "min_height",
                "max_height"
            ],
        "width": {
            "display": "Width",
            "fieldname": [
                "min_width",
                "max_width"
            ],
        "soil": {
            "display": "Soil Condition",
            "fieldname": [
                "DRAIN",
                "SALT"
            ],
        "growth_rate": {
            "display": "Growth Rate",
            "fieldname": [
                "SHORT_LIFE",
                "FAST_GROW",
                "SLOW_GROW"
            ],
         */





        let fieldName = $(this).attr("data-field-name"),
          numFields = $(this).attr("data-field-num"),
          filterField = fieldName,
          filterValue = this_value,
          filterField2,
          filterValue2;
        if (numFields) { //just using this to see if there's more than one, it's a string integer, we'll just look at the fieldName.split('_-_')
          if (showLogs) { info("isMultiField - numFields", numFields, fieldName); }

          let fields = fieldName.split(FIELDSPLIT);
          if (showLogs) { info(fields); }
          if (fields && typeof fields.forEach === "function") {
            if (this_value !== "reset") {
              fields.forEach((f) => {
                if (showLogs) { log(f, this_value); }
                if (f.toLowerCase() === this_value.toLowerCase()) {
                  filterField = this_value;
                  filterValue = "1";
                  log('set filterField', f, filterField, filterValue);
                }
              });
            }


            if (filterField === fieldName) { // isReset || not found, need to handle
              if (showLogs) { info("handle specific situations with switch (%s) fieldName: %s", propName, fieldName); }

              // create a custom filtering function for the operator
              // http://www.telerik.com/forums/custom-filtering-7b617857877c#qVO0bvbdyUeBJLFoPmPWeg
              let opFunct = function (item, value) {
                //info("operator function item,value::", item, value);//item = itemValue ("25.0-25.0""), value = filterValue ("0-3") 
                let min, max,
                  [lower, upper] = item.split('-');
                //extend the ranges to include more results, string->integer
                lower = Math.floor(lower);
                upper = Math.round(upper);
                //info('lower,upper ::',lower,upper);
                if (value.indexOf(FIELDTOINFINITY) > 0) {
                  // only min or greater
                  min = Math.round(value.split(FIELDTOINFINITY)[0]);
                  max = Infinity;
                  //info("min",min);
                } else {
                  // range
                  [min, max] = value.split('-');
                  min = Math.round(min);
                  max = Math.round(max);
                  //info("min,max ::",min, max);
                }

                let devDebug = false;
                if (devDebug) {
                  if (upper >= min && lower <= max) {
                    info("TRUE for operator function: upper %d >= %d min && lower %d <= %d max (( item: %s , value: %s", upper, min, lower, max, item, value);
                  } else {
                    log("FALSE for operator function: upper %d !>= %d min || lower %d !<= %d max (( item: %s , value: %s", upper, min, lower, max, item, value);
                  }
                }

                return upper >= min && lower <= max;
              };



              switch (propName) {
                case "height":
                  filterField = propName;
                  if (showLogs) { info("create height operator function for field: %s && value: %s", filterField, filterValue); }
                  this_op = opFunct;
                  break;
                case "width":
                  filterField = propName;
                  if (showLogs) { info("create width operator function for field: %s && value: %s", filterField, filterValue); }
                  // create a custom filtering function for the operator
                  // http://www.telerik.com/forums/custom-filtering-7b617857877c#qVO0bvbdyUeBJLFoPmPWeg
                  this_op = opFunct;
                  break;
                case "growth_rate":
                  if (filterValue === "not_fast_and_not_slow") {
                    filterField = "fast_grow";
                    filterValue = "0";

                    filterField2 = "slow_grow";
                    filterValue2 = "0";
                  } else if (filterValue === "reset") {
                    filterField = propName;
                  }
                  break;
                case "soil":
                  //info("soil field from to: ",filterField,propName);
                  filterField = propName;
                  break;
              }

            } else {
              if (showLogs) { info('filterField changed from %s to %s', fieldName, filterField); }
            }
          }

        } //end numFields


        // handle other special cases
        switch (propName) {
          case "maintenance":
          case "ecological_role":
          case "ethnobotany":
            if (showLogs) { info("buncha_bools ", propName, filterField, filterValue); }
            if (filterValue !== "reset") {
              filterField = filterValue;
              filterValue = "1";
            }
            break;
        }



        log("click: id=%s && type=%s && name=%s && value=%s && checked[" + (typeof isChecked) + "]=" + isChecked + " && propName=%s", this_id, this_type, this_name, this_value, propName);

        let isReset = (this_value === "reset");
        //log('isReset: ',isReset);

        let sel = "input[name='" + this_name + "']";
        // deal with the reset checkbox option in form
        if (isReset && isChecked) {
          //log("RESET "+propName);
          sel = "input[name='" + this_name + "']";
          $(sel).each(function () {
            (this as any).checked = false;
          });

          (this as any).checked = true;
        } else if (isReset && !isChecked) {
          //log("TODO:  check if it's the last of the group, click reset if it is");
          lastOne = true;
          sel = "input[name='" + this_name + "']";
          $(sel).each(function () {
            if ((this as any).checked) {
              lastOne = false;
            }
          });

          if (lastOne) {
            sel = "#filter_reset_" + propName;
            if ($(sel).length) {
              $(sel).prop('checked', true);
            }
          }
        } else {
          sel = "#filter_reset_" + propName;
          if ($(sel).length) {
            $(sel).prop('checked', false);
          }
        }// end reset checkbox option


        //
        // multiselect tracker
        //

        let itemValue = propName + ":" + this_value;//propName:value
        //var itemDisplay = propDisplay + displayName;


        // get the multiselect object
        let multiselectWidget = multiselect.getWidget();
        // get data items for the selected options.
        //var selecteditems = multiselect.dataItems(); // selected, not all
        //log('selecteditems ['+typeof selecteditems+']',selecteditems);
        let items = multiselectWidget.dataSource.data();
        //log('multiselect.dataSource.data(): %o',items);

        if (isReset) {
          // reset this propName - remove from selected values
          multiselect.removeFromSelectedByPropName(propName);

          //clear(field); // remove any previous
          // App.plants.filters.clear( propName );//fieldName -> filterField
          App.plants.filtersClear(filterField);//
          if (filterField2) {
            App.plants.filtersClear(filterField2);
          }

        } else {
          // not a reset

          if (isChecked) {
            // if it's checked : check if it's in datasource.data, add if not; then add it to dataitems() - multiselect.value(value);
            let bExists = false;
            for (let i = 0; i < items.length; i++) {
              let dataItem = items[i];
              //log(dataItem);
              if (dataItem.value === itemValue) {
                //  multiselect.dataSource.remove(dataItem);
                bExists = true;
              }
            }

            if (!bExists) {
              multiselectWidget.dataSource.add({ name: displayName, value: itemValue });
            }

            // moved to multiselect obj
            multiselect.addToSelected(itemValue);

            // add filter
            // App.plants.filters.add (field, operator, value, logic, bClearOtherFiltersForField);
            //App.plants.filters.add( propName, this_op, this_value, "or", false );
            App.plants.filtersAdd(filterField, this_op, filterValue, "or", false);//fieldName -> filterField , this_value -> filterValue
            if (filterField2) {
              App.plants.filtersAdd(filterField2, this_op, filterValue2, "or", false);//filterValue2
            }

          } else { //not checked
            // remove it from the selected items
            multiselect.removeFromSelected(itemValue);

            // remove filter
            // App.plants.filters.remove( propName, this_value );
            App.plants.filtersRemove(filterField, filterValue);//fieldName -> filterField , this_value -> filterValue
            if (filterField2) {
              App.plants.filtersRemove(filterField2, filterValue2);//filterValue2
            }

            //log("TODO:  check if it's the last of the group, click reset if it is");
            lastOne = true;
            sel = "input[name='" + this_name + "']";
            $(sel).each(function () {
              if ((this as any).checked) {
                lastOne = false;
              }
            });

            if (lastOne) {
              sel = "#filter_reset_" + propName;
              if ($(sel).length) {
                $(sel).prop('checked', true);
              }
            }


          } // end ischecked

        } // end if (!isReset) else



        //multiselect.search("A");
        //multiselect.dataSource.sort({ field: "name", dir: "asc" }); // TODO: needed?
        //log("do we need to re-sort?");

      });//end $(".filter-click-event").off("click").on("click",
    }// end $(".filter-click-event")..length


  } //end addEvents


  public checkStore() {
    groupCollapsed("check filter store");
    let filters = this.getFiltersFromStore();
    log("filters:", filters);
    this.filterPopping = true;
    if (filters && filters.length > 0) {
      //log("filters exists > loop and click away");

      for (let i = 0; i < filters.length; i++) {
        let item = filters[i],
          aItem = Utils.splitStringToArray(item, ":"),
          checkId = "#filter_";
        //log(aItem);
        // click the filters
        if (aItem.length === 2) {
          //App.plants.filters.add( aItem[0], aItem[1] );//done in click handler
          if (aItem[0] === "Search" && aItem[1]) {
            info("Search!", aItem[1]);
            App.plants.setSearch(aItem[1]);
          } else {
            // update form checkboxes
            checkId = "#filter_" + aItem[0] + "_" + aItem[1];
            //log(checkId);
            if ($(checkId).length) {
              $(checkId).click();
            } else {
              info(checkId + " does not exist - what to change?");
            }
          }
        } else {
          info("Hmm, there should be 2 in this value array to make any changes?");
        }
      }
    }
    this.filterPopping = false;
    groupEnd("check filter store");
  }

  public saveFiltersToStore(filters) {
    log('saveFilters: ', filters);
    App.service.localStorageAPI.save("DesertlandPlantSelFilters", filters, true, false);
  }

  public getFiltersFromStore() {
    return App.service.localStorageAPI.get("DesertlandPlantSelFilters", true, false);
  }

}//end filterform
